<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_012"><img alt="Image" src="images/f0009-01.jpg"/></a></p><a id="file_012">
<p class="caption">Leroy R. Grumman, a former naval aviator, took to designing and building what he knew. His company created planes that were often basic and utilitarian, but also incredibly tough. In interviews, he often said, “We always tried to do a solid job.” <em>Grumman History Center</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_012.vue?035d4e68